if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.product-tabs__tab');
        this.panels = this.querySelectorAll('.product-tabs__panel');
        this.currentTab = 0;
      }

      connectedCallback() {
        this.setupEventListeners();
        this.setupKeyboardNavigation();
      }

      setupEventListeners() {
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            this.switchTab(index);
          });
        });
      }

      setupKeyboardNavigation() {
        this.addEventListener('keydown', (e) => {
          const focusedTab = document.activeElement;
          const focusedIndex = Array.from(this.tabs).indexOf(focusedTab);
          
          if (focusedIndex === -1) return;

          switch (e.key) {
            case 'ArrowLeft':
              e.preventDefault();
              this.focusPreviousTab(focusedIndex);
              break;
            case 'ArrowRight':
              e.preventDefault();
              this.focusNextTab(focusedIndex);
              break;
            case 'Home':
              e.preventDefault();
              this.focusTab(0);
              break;
            case 'End':
              e.preventDefault();
              this.focusTab(this.tabs.length - 1);
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              this.switchTab(focusedIndex);
              break;
          }
        });
      }

      switchTab(index) {
        if (index === this.currentTab) return;

        // Update tabs
        this.tabs[this.currentTab].classList.remove('product-tabs__tab--active');
        this.tabs[this.currentTab].setAttribute('aria-selected', 'false');
        this.tabs[this.currentTab].setAttribute('tabindex', '-1');

        this.tabs[index].classList.add('product-tabs__tab--active');
        this.tabs[index].setAttribute('aria-selected', 'true');
        this.tabs[index].setAttribute('tabindex', '0');

        // Update panels
        this.panels[this.currentTab].classList.remove('product-tabs__panel--active');
        this.panels[index].classList.add('product-tabs__panel--active');

        this.currentTab = index;

        // Announce to screen readers
        this.announceTabChange(index);
      }

      focusTab(index) {
        this.tabs[index].focus();
      }

      focusPreviousTab(currentIndex) {
        const previousIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        this.focusTab(previousIndex);
      }

      focusNextTab(currentIndex) {
        const nextIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        this.focusTab(nextIndex);
      }

      announceTabChange(index) {
        const tabName = this.tabs[index].textContent.trim();
        const announcement = `${tabName} tab selected`;
        
        // Create or update live region for screen reader announcements
        let liveRegion = this.querySelector('.sr-only[aria-live]');
        if (!liveRegion) {
          liveRegion = document.createElement('div');
          liveRegion.className = 'sr-only';
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('aria-atomic', 'true');
          this.appendChild(liveRegion);
        }
        
        liveRegion.textContent = announcement;
      }
    }
  );
}
